import { render, staticRenderFns } from "./partnerinfo.vue?vue&type=template&id=1ba29c8c&scoped=true"
import script from "./partnerinfo.vue?vue&type=script&lang=js"
export * from "./partnerinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba29c8c",
  null
  
)

export default component.exports